module.exports = __webpack_public_path__ + "img/fd100.4dd07f54.png";